/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { BackgroundColorKey, BorderColorKey, IconColorKey, TextColorKey } from 'theme/types'

import { ButtonColor, ButtonVariant } from './types'

type PaletteKeys = {
  text: TextColorKey
  icon: IconColorKey
  border: BorderColorKey
}

type VariantKeys = {
  background?: BackgroundColorKey | 'transparent'
  text?: TextColorKey
  icon?: IconColorKey
  border?: BorderColorKey
}

type VariantHoverKeys = {
  background?: BackgroundColorKey
  border?: BorderColorKey
  text?: TextColorKey
}

export const paletteKeysByColor: Record<ButtonColor, PaletteKeys> = {
  brand: { text: 'brandPrimary', icon: 'brandPrimary', border: 'brandPrimary' },
  neutral: { text: 'default', icon: 'default', border: 'default' },
}

export const variantBaseKeys: Record<ButtonVariant, VariantKeys> = {
  primary: {
    background: 'brandPrimary',
    text: 'inverted',
    icon: 'inverted',
    border: 'brandPrimary',
  },
  secondary: {
    background: 'default',
  },
  tertiary: {
    background: 'transparent',
  },
}

export const variantDisabledKeys: Partial<Record<ButtonVariant, VariantKeys>> = {
  primary: {
    background: 'disabled',
    text: 'disabled',
    icon: 'disabled',
    border: 'disabled',
  },
  secondary: {
    background: 'disabled',
    text: 'disabled',
    icon: 'disabled',
    border: 'disabled',
  },
  tertiary: {
    text: 'disabled',
    icon: 'disabled',
  },
}

export const variantHoverKeys: Partial<Record<ButtonVariant, VariantHoverKeys>> = {
  primary: { background: 'brandPrimaryHover', border: 'brandPrimaryHover' },
  secondary: { text: 'brandPrimaryHover', border: 'brandPrimaryHover' },
  tertiary: { text: 'brandPrimaryHover' },
}
